{
  "app.title": "Employees",
  "app.logout": "Logout",
  "app.language": "English",
  "app.settings": "Settings",
  "settings.title": "Synchronisation",
  "settings.send_to_all_apps_users": "Send users to everyone",
  "settings.send_to_all_apps_missions": "Send missions to everyone",
  "settings.sync_with_iam": "Synchronise with IAM",
  "settings.sync_with_erp": "Synchronise with ERP",
  "settings.sync_missions": "Synchronise missions with Salesforce",
  "settings.send_to_all_apps_users.description": "Publishes every user stored in the database to the listening applications, so they can refresh their copy of the employee directory.",
  "settings.send_to_all_apps_missions.description": "Publishes every mission stored in the database to the listening applications, so they can refresh their copy of the missions.",
  "settings.sync_with_iam.description": "Matches each user with their Keycloak account by email, then updates their IAM identifier and roles.",
  "settings.sync_with_erp.description": "Fetches employees from SAP: refreshes jobs and departments, creates new users, updates the ones that changed and deactivates the ones no longer in SAP. Changes are published to the listening applications.",
  "settings.sync_missions.description": "Fetches missions from Salesforce, creates or updates them in the database and publishes the changes to the listening applications.",
  "settings.sync_missing_avatars": "Synchronise missing avatars",
  "settings.sync_missing_avatars.description": "Looks for a profile picture in the Google Drive folder for every user who has no avatar yet.",
  "settings.button.run": "Run",
  "settings.button.running": "Running...",
  "settings.button.stop": "Stop",
  "settings.button.cancel": "Cancel",
  "settings.stop.confirm.title": "Stop this synchronisation?",
  "settings.stop.confirm.description": "It will be marked as failed and can be run again.",
  "settings.last_run": "Last run",
  "settings.last_success": "Last success:",
  "settings.never": "never",
  "settings.never_run": "Never run yet",
  "settings.status.running": "Running",
  "settings.status.success": "Success",
  "settings.status.failure": "Failure",
  "settings.trigger.manual": "Manual",
  "settings.trigger.service_account": "Service account",
  "settings.trigger.scheduled": "Automatic",
  "settings.history.title": "History",
  "settings.history.action": "Action",
  "settings.history.trigger": "Trigger",
  "settings.history.who": "Who",
  "settings.history.started_at": "Started at",
  "settings.history.duration": "Duration",
  "settings.history.status": "Status",
  "info.sync.started.title": "Started",
  "info.sync.started.description": "The result will be displayed on the card.",
  "warning.sync.already_running.title": "Already running",
  "warning.sync.already_running.description": "Already running, started by {author} at {time}",
  "info.sync.stopped.title": "Stopped",
  "info.sync.stopped.description": "The synchronisation can be run again.",
  "info.sync.already_finished.title": "Already finished",
  "info.sync.already_finished.description": "This run had already finished.",
  "table.reset_filters": "Reset filters",
  "table.search_name": "Search by first or last name",
  "table.department_filter": "All departments",
  "table.showing_inactive_user_filter": "Inactive users",
  "table.id": "SAP ID",
  "table.first_name": "First Name",
  "table.last_name": "Last Name",
  "table.starting_date": "Starting Date",
  "table.last_modification": "Last Modified (SAP)",
  "table.job": "Job Title",
  "table.department": "Department",
  "table.roles": "Roles",
  "table.active": "Active",
  "table.inactive": "Inactive",
  "table.role.other": "others",
  "job_title.consultant": "Consultant",
  "job_title.commercial": "Commercial",
  "job_title.direction": "Direction",
  "job_title.staff": "Staff",
  "job_title.intern": "Intern",
  "job_title.pro_contract": "Professional Contract",
  "collaborator.seniority": "Seniority",
  "collaborator.contract_period": "Contract Periods",
  "collaborator.contract": "Contract",
  "collaborator.avatar.upload": "Upload new avatar",
  "collaborator.avatar.delete": "Delete avatar",
  "time.year": "year",
  "time.month": "month",
  "time.day": "day",
  "time.first_day": "First day 💖",
  "vocab.and": "and",
  "language.title": "Error",
  "language.description": "Language switch not available",
  "success.title": "Success",
  "success.avatar.upload.description": "Avatar successfully uploaded",
  "success.avatar.delete.description": "Avatar successfully deleted",
  "error.title": "Error",
  "error.back_to_home": "Back to home",
  "error.sync.description": "Failed to synchronise",
  "error.sync.stop.description": "Failed to stop the synchronisation",
  "error.not_found.title": "Error 404",
  "error.not_found.sub_title": "Sorry, the page you visited does not exist.",
  "error.forbidden.title": "Error 403",
  "error.forbidden.sub_title": "Sorry, you are not authorized to access this website.",
  "error.users.description": "Failed to access users",
  "error.missions.description": "Failed to access missions",
  "app.missions": "Missions",
  "table.search_mission": "Search by user email or client",
  "table.mission_name": "Mission",
  "table.yes": "Yes",
  "table.no": "No",
  "table.client_name": "Client",
  "table.takima_user_email": "Takima Email",
  "table.start_date": "Start Date",
  "table.end_date": "End Date",
  "table.mission_ended": "Finished",
  "table.showing_ended_mission_filter": "Finished missions only",
  "table.search_client_name": "Search by client name",
  "table.search_takima_email": "Search by Takima email",
  "error.user.description": "Failed to access user ({userId})",
  "error.avatar.upload.description": "Failed to upload avatar",
  "error.avatar.delete.description": "Failed to delete avatar",
  "error.avatar.type": "Invalid file type",
  "error.avatar.type.description": "File type must be JPEG or PNG!",
  "error.avatar.size": "File too large",
  "error.avatar.size.description": "File too large. Please upload a file smaller than 1MB.",
  "app.back": "Back",
  "users.eyebrow": "Directory",
  "users.empty": "No employee matches these filters",
  "users.total": "{total, plural, one {# employee} other {# employees}}",
  "users.filter.all": "All",
  "users.filter.active": "Active",
  "users.last_erp_sync": "Last ERP synchronisation",
  "users.manage_sync": "Manage",
  "missions.eyebrow": "Staffing",
  "settings.eyebrow": "Administration",
  "collaborator.avatar.edit": "Change avatar",
  "collaborator.information": "Information",
  "collaborator.contract.current": "Current",
  "collaborator.contract.open_ended": "Today",
  "collaborator.missions.empty": "No mission yet",
  "collaborator.missions.ongoing": "Ongoing",
  "collaborator.missions.prolongations": "{count, plural, one {# extension} other {# extensions}}",
  "error.user.not_found": "Employee not found",
  "table.on_bench": "On bench",
  "collaborator.status": "Status",
  "table.takima_user": "Employee",
  "table.search_takima_user": "Search by employee name or email"
}
